import {
  bannerWidgetDefaultBodyText,
  cardWidgetDefaultBodyText,
  slideShowWidgetDefaultBodyText,
  tabsCardBodyText,
  widgetTypes,
} from './constants';

export const getInitialChildren = (
  widgetType: string,
  site?: Site,
  index?: number
) => {
  const initialChildren = {
    Tabs: [
      {
        widgetType: widgetTypes.Section,
        x: 5,
        y: 95,
        originalYLocation: 95,
        width: 1190,
        height: 498,
        minWidth: 100,
        minHeight: 40,
        backgroundData: {
          style: 'Image',
          color: '',
        },
        backgroundImage: {
          url:
            'https://cdn-stage.linkhealth.com/site-builder/horizon/Tab1Background.png',
          alt: 'tab 1 background',
        },
        tabIndex: 0,
      },
      {
        widgetType: widgetTypes.Text,
        x: 44,
        y: 190,
        originalYLocation: 190,
        text: 'Get the support you need in person, virtually or digitally',
        bold: true,
        width: 260,
        height: 110,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        fontSize: 26,
        textColor: '#414445',
        tabIndex: 0,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Card,
        x: 44,
        y: 360,
        originalYLocation: 360,
        width: 350,
        height: 194,
        minWidth: 180,
        minHeight: 40,
        tabIndex: 0,
        backgroundData: {
          style: 'Color',
          color: 'white',
        },
        uniqueId: 'Tab1Card1',
      },
      {
        widgetType: widgetTypes.Card,
        x: 421,
        y: 360,
        originalYLocation: 360,
        width: 350,
        height: 194,
        minWidth: 180,
        minHeight: 40,
        tabIndex: 0,
        backgroundData: {
          style: 'Color',
          color: 'white',
        },
        uniqueId: 'Tab1Card2',
      },
      {
        widgetType: widgetTypes.Card,
        x: 800,
        y: 360,
        originalYLocation: 360,
        width: 350,
        height: 194,
        minWidth: 180,
        minHeight: 40,
        tabIndex: 0,
        backgroundData: {
          style: 'Color',
          color: 'white',
        },
        uniqueId: 'Tab1Card3',
      },
      {
        widgetType: widgetTypes.Section,
        x: 5,
        y: 95,
        originalYLocation: 95,
        width: 1190,
        height: 498,
        minWidth: 100,
        minHeight: 40,
        backgroundData: {
          style: 'Image',
          color: '',
        },
        backgroundImage: {
          url:
            'https://cdn-stage.linkhealth.com/site-builder/horizon/Tab2Background.png',
          alt: '',
        },
        tabIndex: 1,
        visible: false,
      },
      {
        widgetType: widgetTypes.Text,
        x: 44,
        y: 190,
        originalYLocation: 190,
        text: 'Helping you prepare and save for health care expenses',
        bold: true,
        textColor: '#414445',
        width: 300,
        height: 110,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        fontSize: 26,
        tabIndex: 1,
        visible: false,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Card,
        x: 44,
        y: 360,
        originalYLocation: 360,
        width: 350,
        height: 194,
        minWidth: 180,
        minHeight: 40,
        tabIndex: 1,
        visible: false,
        backgroundData: {
          style: 'Color',
          color: 'white',
        },
        uniqueId: 'Tab2Card1',
      },
      {
        widgetType: widgetTypes.Card,
        x: 421,
        y: 360,
        originalYLocation: 360,
        width: 350,
        height: 194,
        minWidth: 180,
        minHeight: 40,
        tabIndex: 1,
        visible: false,
        backgroundData: {
          style: 'Color',
          color: 'white',
        },
        uniqueId: 'Tab2Card2',
      },
      {
        widgetType: widgetTypes.Card,
        x: 800,
        y: 360,
        originalYLocation: 360,
        width: 350,
        height: 194,
        minWidth: 180,
        minHeight: 40,
        tabIndex: 1,
        visible: false,
        backgroundData: {
          style: 'Color',
          color: 'white',
        },
        uniqueId: 'Tab2Card3',
      },
    ],
    Tab1Card1: [
      {
        widgetType: widgetTypes.Text,
        x: 54,
        y: 374,
        originalYLocation: 374,
        text: 'Text Category 1',
        bold: true,
        width: 200,
        textColor: '#414445',
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 54,
        y: 420,
        originalYLocation: 420,
        text: tabsCardBodyText,
        bold: false,
        textColor: '#414445',
        width: 300,
        height: 75,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 54,
        y: 506,
        originalYLocation: 506,
        text: 'Getting Started >',
        bold: true,
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        textColor: '#196ece',
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
    ],
    Tab1Card2: [
      {
        widgetType: widgetTypes.Text,
        x: 431,
        y: 374,
        originalYLocation: 374,
        text: 'Text Category 1',
        bold: true,
        textColor: '#414445',
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 431,
        y: 420,
        originalYLocation: 420,
        text: tabsCardBodyText,
        bold: false,
        textColor: '#414445',
        width: 300,
        height: 75,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 431,
        y: 506,
        originalYLocation: 506,
        text: 'Getting Started >',
        bold: true,
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        textColor: '#196ece',
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
    ],
    Tab1Card3: [
      {
        widgetType: widgetTypes.Text,
        x: 810,
        y: 374,
        originalYLocation: 374,
        text: 'Text Category 1',
        bold: true,
        textColor: '#414445',
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 810,
        y: 420,
        originalYLocation: 420,
        text: tabsCardBodyText,
        bold: false,
        textColor: '#414445',
        width: 300,
        height: 75,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 810,
        y: 506,
        originalYLocation: 506,
        text: 'Getting Started >',
        bold: true,
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 0,
        fontSize: 16,
        textColor: '#196ece',
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
    ],
    Tab2Card1: [
      {
        widgetType: widgetTypes.Text,
        x: 54,
        y: 374,
        originalYLocation: 374,
        text: 'Text Category 1',
        bold: true,
        textColor: '#414445',
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 54,
        y: 420,
        originalYLocation: 420,
        text: tabsCardBodyText,
        bold: false,
        textColor: '#414445',
        width: 300,
        height: 75,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 54,
        y: 506,
        originalYLocation: 506,
        text: 'Getting Started >',
        bold: true,
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        visible: false,
        textColor: '#196ece',
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
    ],
    Tab2Card2: [
      {
        widgetType: widgetTypes.Text,
        x: 431,
        y: 374,
        originalYLocation: 374,
        text: 'Text Category 1',
        bold: true,
        textColor: '#414445',
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 431,
        y: 420,
        originalYLocation: 420,
        text: tabsCardBodyText,
        bold: false,
        textColor: '#414445',
        width: 300,
        height: 75,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 431,
        y: 506,
        originalYLocation: 506,
        text: 'Getting Started >',
        bold: true,
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        textColor: '#196ece',
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
    ],
    Tab2Card3: [
      {
        widgetType: widgetTypes.Text,
        x: 810,
        y: 374,
        originalYLocation: 374,
        text: 'Text Category 1',
        bold: true,
        textColor: '#414445',
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 810,
        y: 420,
        originalYLocation: 420,
        text: tabsCardBodyText,
        bold: false,
        textColor: '#414445',
        width: 300,
        height: 75,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 810,
        y: 506,
        originalYLocation: 506,
        text: 'Getting Started >',
        bold: true,
        width: 200,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        tabIndex: 1,
        fontSize: 16,
        visible: false,
        textColor: '#196ece',
        backgroundData: {
          style: 'None',
          color: 'transparent',
        },
      },
    ],
    Card: [
      {
        widgetType: widgetTypes.Text,
        x: 10,
        y: 20,
        originalYLocation: 20,
        text: 'Heading',
        bold: true,
        textColor: '#414445',
        width: 400,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        backgroundData: { style: 'Color', color: 'white' },
        fontSize: 26,
        font: 'UHCSans',
      },
      {
        widgetType: widgetTypes.Image,
        x: 10,
        y: 70,
        originalYLocation: 70,
        width: 400,
        height: 215,
        minWidth: 100,
        minHeight: 40,
        backgroundImage: {
          url:
            'https://cdn-stage.linkhealth.com/site-builder/horizon/CardTemplateImage.png',
          alt: '',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 10,
        y: 292,
        originalYLocation: 292,
        text: 'Subheading',
        textColor: '#414445',
        bold: true,
        width: 400,
        height: 30,
        minWidth: 180,
        minHeight: 30,
        fontSize: 16,
        align: 'none',
        backgroundData: { style: 'Color', color: 'white' },
      },
      {
        widgetType: widgetTypes.Text,
        x: 10,
        y: 329,
        originalYLocation: 329,
        text: cardWidgetDefaultBodyText,
        bold: false,
        textColor: '#414445',
        width: 400,
        height: 95,
        minWidth: 180,
        minHeight: 40,
        fontSize: 16,
        align: 'none',
        backgroundData: { style: 'Color', color: 'white' },
      },
      {
        widgetType: widgetTypes.Button,
        x: 10,
        y: 433,
        originalYLocation: 433,
        displayText: 'My Button Text',
        bold: true,
        width: 400,
        height: 60,
        minWidth: 180,
        minHeight: 60,
        align: 'center',
        paddingData: { top: 5, bottom: 5, left: 5, right: 5 },
        textColor: 'white',
        backgroundData: { style: 'Color', color: '#002677' },
        borderData: { thickness: 0, radius: 50 },
        lineColor: 'white',
        hoverData: {
          font: 'OptumSans',
          textColor: 'white',
          fontSize: 16,
          bold: true,
          align: 'center',
          italic: false,
          underline: false,
          strikeThrough: false,
          characterSpacing: 0,
          lineSpacing: 1,
          lineColor: 'white',
          borderData: { thickness: 0, radius: 50 },
          backgroundData: { style: 'Color', color: '#002677' },
          iconStyle: 'Without Icon',
          icon: {
            url: '',
            alt: '',
          },
          iconPlacement: 'Left',
        },
      },
      {
        widgetType: widgetTypes.Button,
        x: 10,
        y: 502,
        originalYLocation: 502,
        displayText: 'My Button Text',
        bold: true,
        width: 400,
        height: 60,
        minWidth: 180,
        minHeight: 60,
        align: 'center',
        paddingData: { top: 5, bottom: 5, left: 5, right: 5 },
        backgroundData: { style: 'Color', color: 'white' },
        textColor: '#002677',
        borderData: { thickness: 2, radius: 50 },
        lineColor: '#002677',
        hoverData: {
          font: 'OptumSans',
          textColor: '#002677',
          fontSize: 16,
          bold: true,
          align: 'center',
          italic: false,
          underline: false,
          strikeThrough: false,
          characterSpacing: 0,
          lineSpacing: 1,
          lineColor: '#002677',
          borderData: { thickness: 2, radius: 50 },
          backgroundData: { style: 'Color', color: 'white' },
          iconStyle: 'Without Icon',
          icon: {
            url: '',
            alt: '',
          },
          iconPlacement: 'Left',
        },
      },
    ],
    Form: [
      {
        widgetType: widgetTypes.Text,
        x: 10,
        y: 20,
        originalYLocation: 20,
        text: 'Your Form Title',
        fontSize: 32,
        bold: true,
        textColor: '#414445',
        width: 400,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        backgroundData: { style: 'Color', color: 'white' },
      },
      {
        widgetType: widgetTypes.Text,
        x: 10,
        y: 70,
        originalYLocation: 70,
        text: 'All fields with an asterisk (*) are required',
        fontSize: 16,
        bold: false,
        textColor: '#414445',
        width: 400,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        backgroundData: { style: 'Color', color: 'white' },
      },
      {
        widgetType: widgetTypes.TextInput,
        x: 10,
        y: 120,
        originalYLocation: 120,
        label: 'Name',
        required: true,
        width: 400,
        height: 85,
        minWidth: 100,
        minHeight: 40,
        textColor: '#414445',
      },
      {
        widgetType: widgetTypes.TextInput,
        x: 10,
        y: 220,
        originalYLocation: 220,
        label: 'E-Mail Address',
        required: true,
        width: 400,
        height: 85,
        minWidth: 180,
        minHeight: 30,
        textColor: '#414445',
      },
      {
        widgetType: widgetTypes.TextInput,
        x: 10,
        y: 320,
        originalYLocation: 320,
        label: 'Contact Number',
        required: false,
        width: 400,
        height: 85,
        minWidth: 180,
        minHeight: 30,
      },
      {
        widgetType: widgetTypes.RadioButton,
        x: 10,
        y: 420,
        originalYLocation: 420,
        label: 'Preferred Contact Method',
        required: false,
        width: 400,
        height: 85,
        minWidth: 180,
        minHeight: 30,
        value: 'Call, Text, E-Mail',
        textColor: '#414445',
      },
      {
        widgetType: widgetTypes.Button,
        x: 95,
        y: 520,
        originalYLocation: 520,
        displayText: 'Submit',
        action: 'submit',
        bold: true,
        width: 240,
        height: 60,
        minWidth: 180,
        minHeight: 60,
        align: 'center',
        paddingData: { top: 5, bottom: 5, left: 5, right: 5 },
        textColor: 'white',
        backgroundData: { style: 'Color', color: '#002677' },
        borderData: { thickness: 0, radius: 50 },
        lineColor: '',
        site: site,
        hoverData: {
          font: 'OptumSans',
          textColor: 'white',
          fontSize: 16,
          bold: true,
          align: 'center',
          italic: false,
          underline: false,
          strikeThrough: false,
          characterSpacing: 0,
          lineSpacing: 1,
          lineColor: '',
          borderData: { thickness: 0, radius: 50 },
          backgroundData: { style: 'Color', color: '#002677' },
          iconStyle: 'Without Icon',
          icon: {
            url: '',
            alt: '',
          },
          iconPlacement: 'Left',
        },
      },
    ],
    Banner: [
      {
        widgetType: widgetTypes.Image,
        x: 10,
        y: 30,
        originalYLocation: 30,
        width: 30,
        height: 30,
        minWidth: 10,
        minHeight: 10,
        backgroundImage: {
          url: 'https://cdn-stage.linkhealth.com/site-builder/horizon/Flag.png',
          alt: '',
        },
      },
      {
        widgetType: widgetTypes.Text,
        x: 60,
        y: 10,
        originalYLocation: 10,
        text: bannerWidgetDefaultBodyText,
        bold: false,
        textColor: '#414445',
        width: 900,
        height: 80,
        minWidth: 180,
        minHeight: 40,
        align: 'none',
        fontSize: 16,
        backgroundData: { style: 'Color', color: '#EEF4FF' },
      },
      {
        widgetType: widgetTypes.Divider,
        x: 0,
        y: 60,
        originalYLocation: 60,
        bold: false,
        width: 1000,
        height: 31,
        minWidth: 31,
        minHeight: 31,
        align: 'none',
        lineColor: '#224AA1',
      },
    ],
    Slideshow: [
      {
        widgetType: widgetTypes.Image,
        x: 79,
        y: 36,
        originalYLocation: 36,
        width: 413,
        height: 232,
        minWidth: 10,
        minHeight: 10,
        backgroundImage: {
          url:
            'https://cdn-stage.linkhealth.com/site-builder/horizon/image-placeholder.png',
          alt: '',
        },
        visible: true,
        tabIndex: 0,
      },

      {
        widgetType: widgetTypes.Text,
        x: 532,
        y: 36,
        originalYLocation: 36,
        text: 'Slideshow Heading 1',
        bold: true,
        textColor: '#414445',
        width: 600,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        fontSize: 24,
        align: 'none',
        visible: true,
        tabIndex: 0,
      },

      {
        widgetType: widgetTypes.Text,
        x: 532,
        y: 78,
        originalYLocation: 78,
        text: slideShowWidgetDefaultBodyText,
        bold: false,
        textColor: '#414445',
        width: 600,
        height: 135,
        minWidth: 180,
        minHeight: 40,
        fontSize: 15,
        align: 'none',
        visible: true,
        tabIndex: 0,
      },

      {
        widgetType: widgetTypes.Button,
        x: 531,
        y: 217,
        originalYLocation: 217,
        displayText: 'My Button Text',
        bold: true,
        width: 240,
        height: 50,
        minWidth: 100,
        minHeight: 10,
        align: 'center',
        paddingData: { top: 5, bottom: 5, left: 5, right: 5 },
        textColor: 'white',
        backgroundData: { style: 'Color', color: '#002677' },
        borderData: { thickness: 0, radius: 50 },
        lineColor: 'white',
        tabIndex: 0,
        visible: true,
        hoverData: {
          font: 'OptumSans',
          textColor: 'white',
          fontSize: 16,
          bold: true,
          align: 'center',
          italic: false,
          underline: false,
          strikeThrough: false,
          characterSpacing: 0,
          lineSpacing: 1,
          lineColor: 'white',
          borderData: { thickness: 0, radius: 50 },
          backgroundData: { style: 'Color', color: '#002677' },
          iconStyle: 'Without Icon',
          icon: {
            url: '',
            alt: '',
          },
          iconPlacement: 'Left',
        },
      },

      {
        widgetType: widgetTypes.Image,
        x: 79,
        y: 36,
        originalYLocation: 36,
        width: 413,
        height: 232,
        minWidth: 10,
        minHeight: 10,
        backgroundImage: {
          url:
            'https://cdn-stage.linkhealth.com/site-builder/horizon/image-placeholder.png',
          alt: '',
        },
        tabIndex: 1,
        visible: false,
      },

      {
        widgetType: widgetTypes.Text,
        x: 532,
        y: 36,
        originalYLocation: 36,
        text: 'Slideshow Heading 2',
        bold: true,
        textColor: '#414445',
        width: 600,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        fontSize: 24,
        align: 'none',
        tabIndex: 1,
        visible: false,
      },

      {
        widgetType: widgetTypes.Text,
        x: 532,
        y: 78,
        originalYLocation: 78,
        text: slideShowWidgetDefaultBodyText,
        bold: false,
        textColor: '#414445',
        width: 600,
        height: 135,
        minWidth: 180,
        minHeight: 40,
        fontSize: 15,
        align: 'none',
        tabIndex: 1,
        visible: false,
      },

      {
        widgetType: widgetTypes.Button,
        x: 531,
        y: 217,
        originalYLocation: 217,
        displayText: 'My Button Text',
        bold: true,
        width: 240,
        height: 50,
        minWidth: 100,
        minHeight: 10,
        align: 'center',
        paddingData: { top: 5, bottom: 5, left: 5, right: 5 },
        textColor: 'white',
        backgroundData: { style: 'Color', color: '#002677' },
        borderData: { thickness: 0, radius: 50 },
        lineColor: 'white',
        tabIndex: 1,
        visible: false,
        hoverData: {
          font: 'OptumSans',
          textColor: 'white',
          fontSize: 16,
          bold: true,
          align: 'center',
          italic: false,
          underline: false,
          strikeThrough: false,
          characterSpacing: 0,
          lineSpacing: 1,
          lineColor: 'white',
          borderData: { thickness: 0, radius: 50 },
          backgroundData: { style: 'Color', color: '#002677' },
          iconStyle: 'Without Icon',
          icon: {
            url: '',
            alt: '',
          },
          iconPlacement: 'Left',
        },
      },

      {
        widgetType: widgetTypes.Image,
        x: 79,
        y: 36,
        originalYLocation: 36,
        width: 413,
        height: 232,
        minWidth: 10,
        minHeight: 10,
        backgroundImage: {
          url:
            'https://cdn-stage.linkhealth.com/site-builder/horizon/image-placeholder.png',
          alt: '',
        },
        tabIndex: 2,
      },

      {
        widgetType: widgetTypes.Text,
        x: 532,
        y: 36,
        originalYLocation: 36,
        text: 'Slideshow Heading 3',
        textColor: '#414445',
        bold: true,
        width: 600,
        height: 40,
        minWidth: 180,
        minHeight: 40,
        fontSize: 24,
        align: 'none',
        tabIndex: 2,
      },

      {
        widgetType: widgetTypes.Text,
        x: 532,
        y: 78,
        originalYLocation: 78,
        text: slideShowWidgetDefaultBodyText,
        bold: false,
        textColor: '#414445',
        width: 600,
        height: 135,
        minWidth: 180,
        minHeight: 40,
        fontSize: 15,
        align: 'none',
        tabIndex: 2,
      },

      {
        widgetType: widgetTypes.Button,
        x: 531,
        y: 217,
        originalYLocation: 217,
        displayText: 'My Button Text',
        bold: true,
        width: 240,
        height: 50,
        minWidth: 100,
        minHeight: 10,
        align: 'center',
        paddingData: { top: 5, bottom: 5, left: 5, right: 5 },
        textColor: 'white',
        backgroundData: { style: 'Color', color: '#002677' },
        borderData: { thickness: 0, radius: 50 },
        lineColor: 'white',
        tabIndex: 2,
        hoverData: {
          font: 'OptumSans',
          textColor: 'white',
          fontSize: 16,
          bold: true,
          align: 'center',
          italic: false,
          underline: false,
          strikeThrough: false,
          characterSpacing: 0,
          lineSpacing: 1,
          lineColor: 'white',
          borderData: { thickness: 0, radius: 50 },
          backgroundData: { style: 'Color', color: '#002677' },
          iconStyle: 'Without Icon',
          icon: {
            url: '',
            alt: '',
          },
          iconPlacement: 'Left',
        },
      },
    ],
    RepeaterWidget: [
      {
        widgetType: widgetTypes.Section,
        x: 23,
        y: 26,
        width: 350,
        height: 287,
        minWidth: 180,
        minHeight: 40,
        borderData: { thickness: 2, radius: 50 },
        lineColor: '#002677',
        repeaterWidgetIndex: 1,
      },
      {
        widgetType: widgetTypes.Section,
        x: 406,
        y: 26,
        width: 350,
        height: 287,
        minWidth: 180,
        minHeight: 40,
        borderData: { thickness: 2, radius: 50 },
        lineColor: '#002677',
        repeaterWidgetIndex: 2,
      },
      {
        widgetType: widgetTypes.Section,
        x: 789,
        y: 26,
        width: 350,
        height: 287,
        minWidth: 180,
        minHeight: 40,
        borderData: { thickness: 2, radius: 20 },
        lineColor: '#002677',
        repeaterWidgetIndex: 3,
      },
    ],
    RepeaterSectionChildren: [
      [
        {
          widgetType: widgetTypes.Text,
          x: 47,
          y: 41,
          text: 'Product 1',
          bold: true,
          width: 200,
          textColor: '#414445',
          height: 40,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Card Name',
          repeaterWidgetId: 1,
        },
        {
          widgetType: widgetTypes.Text,
          x: 47,
          y: 89,
          text: 'Text 1',
          bold: false,
          textColor: '#414445',
          width: 200,
          height: 40,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Card Description',
          repeaterWidgetId: 2,
        },
        {
          widgetType: widgetTypes.Text,
          x: 47,
          y: 137,
          text: tabsCardBodyText,
          bold: false,
          textColor: '#414445',
          width: 300,
          height: 75,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Description',
          repeaterWidgetId: 3,
        },
        {
          widgetType: widgetTypes.Link,
          x: 47,
          y: 219,
          height: 34,
          width: 203,
          minWidth: 180,
          minHeight: 40,
          displayText: 'Text Link 1',
          emailAddress: '',
          emailSubject: '',
          url: '',
          newTab: true,
          bold: false,
          italic: false,
          fontSize: 12,
          font: 'OptumSans',
          underline: true,
          strikeThrough: false,
          characterSpacing: 0,
          fontFamily: 'OptumSans',
          lineSpacing: 1,
          textColor: 'black',
          iconColor: 'black',
          iconBackgroundColor: 'white',
          linkType: 'None',
          repeaterWidgetKey: 'Link1',
          repeaterWidgetId: 4,
        },
        {
          widgetType: widgetTypes.Link,
          x: 47,
          y: 261,
          height: 34,
          width: 267,
          minWidth: 180,
          minHeight: 40,
          displayText: 'Longer than normal text link',
          emailAddress: '',
          emailSubject: '',
          url: '',
          newTab: true,
          bold: false,
          italic: false,
          fontSize: 12,
          font: 'OptumSans',
          underline: true,
          strikeThrough: false,
          characterSpacing: 0,
          fontFamily: 'OptumSans',
          lineSpacing: 1,
          textColor: 'black',
          iconColor: 'black',
          iconBackgroundColor: 'white',
          linkType: 'None',
          repeaterWidgetKey: 'Link2',
          repeaterWidgetId: 5,
        },
      ],
      [
        {
          widgetType: widgetTypes.Text,
          x: 428,
          y: 41,
          text: 'Product 2',
          bold: true,
          width: 200,
          textColor: '#414445',
          height: 40,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Card Name',
          repeaterWidgetId: 1,
        },
        {
          widgetType: widgetTypes.Text,
          x: 428,
          y: 89,
          text: 'Text 1',
          bold: false,
          textColor: '#414445',
          width: 200,
          height: 40,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Card Description',
          repeaterWidgetId: 2,
        },
        {
          widgetType: widgetTypes.Text,
          x: 428,
          y: 137,
          text: tabsCardBodyText,
          bold: false,
          textColor: '#414445',
          width: 300,
          height: 75,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Description',
          repeaterWidgetId: 3,
        },
        {
          widgetType: widgetTypes.Link,
          x: 428,
          y: 219,
          height: 34,
          width: 203,
          minWidth: 180,
          minHeight: 40,
          displayText: 'Text Link 1',
          emailAddress: '',
          emailSubject: '',
          url: '',
          newTab: true,
          bold: false,
          italic: false,
          fontSize: 12,
          font: 'OptumSans',
          underline: true,
          strikeThrough: false,
          characterSpacing: 0,
          fontFamily: 'OptumSans',
          lineSpacing: 1,
          textColor: 'black',
          iconColor: 'black',
          iconBackgroundColor: 'white',
          linkType: 'None',
          repeaterWidgetKey: 'Link1',
          repeaterWidgetId: 4,
        },
        {
          widgetType: widgetTypes.Link,
          x: 428,
          y: 261,
          height: 34,
          width: 267,
          minWidth: 180,
          minHeight: 40,
          displayText: 'Longer than normal text link',
          emailAddress: '',
          emailSubject: '',
          url: '',
          newTab: true,
          bold: false,
          italic: false,
          fontSize: 12,
          font: 'OptumSans',
          underline: true,
          strikeThrough: false,
          characterSpacing: 0,
          fontFamily: 'OptumSans',
          lineSpacing: 1,
          textColor: 'black',
          iconColor: 'black',
          iconBackgroundColor: 'white',
          linkType: 'None',
          repeaterWidgetKey: 'Link2',
          repeaterWidgetId: 5,
        },
      ],
      [
        {
          widgetType: widgetTypes.Text,
          x: 811,
          y: 41,
          text: 'Product 3',
          bold: true,
          width: 200,
          textColor: '#414445',
          height: 40,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Card Name',
          repeaterWidgetId: 1,
        },
        {
          widgetType: widgetTypes.Text,
          x: 811,
          y: 89,
          text: 'Text 1',
          bold: false,
          textColor: '#414445',
          width: 200,
          height: 40,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Card Description',
          repeaterWidgetId: 2,
        },
        {
          widgetType: widgetTypes.Text,
          x: 811,
          y: 137,
          text: tabsCardBodyText,
          bold: false,
          textColor: '#414445',
          width: 300,
          height: 75,
          minWidth: 180,
          minHeight: 40,
          align: 'none',
          tabIndex: 0,
          backgroundData: {
            style: 'None',
            color: 'transparent',
          },
          repeaterWidgetKey: 'Description',
          repeaterWidgetId: 3,
        },
        {
          widgetType: widgetTypes.Link,
          x: 811,
          y: 219,
          height: 34,
          width: 203,
          minWidth: 180,
          minHeight: 40,
          displayText: 'Text Link 1',
          emailAddress: '',
          emailSubject: '',
          url: '',
          newTab: true,
          bold: false,
          italic: false,
          fontSize: 12,
          font: 'OptumSans',
          underline: true,
          strikeThrough: false,
          characterSpacing: 0,
          fontFamily: 'OptumSans',
          lineSpacing: 1,
          textColor: 'black',
          iconColor: 'black',
          iconBackgroundColor: 'white',
          linkType: 'None',
          repeaterWidgetKey: 'Link1',
          repeaterWidgetId: 4,
        },
        {
          widgetType: widgetTypes.Link,
          x: 811,
          y: 261,
          height: 34,
          width: 267,
          minWidth: 180,
          minHeight: 40,
          displayText: 'Longer than normal text link',
          emailAddress: '',
          emailSubject: '',
          url: '',
          newTab: true,
          bold: false,
          italic: false,
          fontSize: 12,
          font: 'OptumSans',
          underline: true,
          strikeThrough: false,
          characterSpacing: 0,
          fontFamily: 'OptumSans',
          lineSpacing: 1,
          textColor: 'black',
          iconColor: 'black',
          iconBackgroundColor: 'white',
          linkType: 'None',
          repeaterWidgetKey: 'Link2',
          repeaterWidgetId: 5,
        },
      ],
    ],
  };
  if (index) {
    return initialChildren[widgetType][index] || [];
  } else {
    return initialChildren[widgetType] || [];
  }
};
